import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@chatterbug/aaron'

const DEFAULT = {
  borderColor: 'gray80',
}

const ACTIVE_FILTERS_CLOSED = {
  borderColor: 'blue42',
}

const FilterButton = ({
  onClick,
  label,
  filterCount,
  showPopout,
  accessibilityLabel,
  buttonRef,
}) => {
  const activeFilters = filterCount > 0
  const activeFiltersAndClosed = activeFilters && !showPopout
  const noFiltersAndClosed = filterCount < 1 && !showPopout

  let styles
  if (activeFiltersAndClosed) {
    styles = ACTIVE_FILTERS_CLOSED
  } else if (noFiltersAndClosed || showPopout) {
    styles = DEFAULT
  }

  return (
    <Flex
      ref={buttonRef}
      as="button"
      px="2x"
      py="1x"
      fontSize="xs"
      fontWeight="normal"
      gridGap="1x"
      position="relative"
      borderWidth="small"
      borderStyle="solid"
      onClick={onClick}
      borderRadius="40px"
      aria-pressed={showPopout}
      bg={showPopout ? 'gray88' : 'white100'}
      sx={{
        ...styles,
        position: 'relative',
        ':hover': {
          cursor: 'pointer',
        },
      }}
    >
      <Box as="p" lineHeight="21px" aria-label={accessibilityLabel || label}>
        {label}
      </Box>
      {activeFilters && (
        <Box
          ml="1x"
          color="white"
          minWidth="20px"
          height="21px"
          px="0,25x"
          lineHeight="20px"
          bg="blue42"
          as="p"
          borderRadius="20px"
        >
          {filterCount}
        </Box>
      )}
    </Flex>
  )
}

FilterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  accessibilityLabel: PropTypes.string,
  filterCount: PropTypes.number,
  showPopout: PropTypes.bool,
  buttonRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
}

export default FilterButton
